import LayoutBlank from '@/layouts/LayoutBlank.vue';
import { viewNamePrefix } from '@/router/routerConstants';
import { UserGroup } from '@/types';

export default [
  {
    path: ':id',
    component: LayoutBlank,
    redirect: '/:locale/insertion/:id/details',
    children: [
      {
        path: 'details',
        name: 'details',
        component: () => import('@/views/DetailsPage/DetailsPage.vue'),
        meta: {
          authorizedGroups: [UserGroup.CUSTOMER_SERVICE_AGENT, UserGroup.PRIVATE],
          viewName: `${viewNamePrefix} Details Page`,
        },
      },
      {
        path: 'bundles',
        name: 'bundles',
        component: () => import('@/views/BundlesPage/BundlesPage.vue'),
        meta: {
          authorizedGroups: [UserGroup.CUSTOMER_SERVICE_AGENT, UserGroup.PRIVATE],
          viewName: `${viewNamePrefix} Bundles Page`,
        },
      },
      {
        path: 'billing',
        name: 'billing',
        component: () => import('@/views/BillingPage/BillingPage.vue'),
        meta: {
          authorizedGroups: [UserGroup.CUSTOMER_SERVICE_AGENT, UserGroup.PRIVATE],
          viewName: `${viewNamePrefix} Billing Page`,
        },
      },
      {
        path: 'confirmation',
        name: 'confirmation',
        component: () => import('@/views/ConfirmationPage/ConfirmationPage.vue'),
        meta: {
          authorizedGroups: [UserGroup.CUSTOMER_SERVICE_AGENT, UserGroup.PRIVATE],
          viewName: `${viewNamePrefix} Confirmation Page`,
        },
      },
      {
        path: 'preview',
        name: 'preview',
        component: () => import('@/views/PreviewPage/PreviewPage.vue'),
        meta: {
          authorizedGroups: [UserGroup.CUSTOMER_SERVICE_AGENT, UserGroup.PRIVATE],
          viewName: `${viewNamePrefix} Preview Page`,
        },
      },
    ],
    meta: {
      authorizedGroups: [UserGroup.CUSTOMER_SERVICE_AGENT, UserGroup.PRIVATE],
      viewName: `${viewNamePrefix} View Page`,
    },
  },
];
